import { clsx } from 'clsx'
import { type ComponentProps, type JSX } from 'react'

type DialogContentProps = ComponentProps<'div'>

export const DialogContent = (props: DialogContentProps): JSX.Element => {
  const { children, className, ...rest } = props

  return (
    <div className={clsx('dialog-content', className)} {...rest}>
      {children}
    </div>
  )
}
